import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id FC112FD8-5338-49C0-B4E0-FE1816A71E74
 * name shield-check
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/shield-check.svg
 * tags
 * - Account / User 
 */
export const ShieldCheckIcon = createSvgIcon(<><path d="M10,17L6,13L7.41,11.59L10,14.17L16.59,7.58L18,9M12,1L3,5V11C3,16.55 6.84,21.74 12,23C17.16,21.74 21,16.55 21,11V5L12,1Z" /></>, 'ShieldCheckIcon');
export default ShieldCheckIcon